const errors = {
  boardNotFound: { code: 'boards/notFound', message: 'Board not found' }
}

export default errors
